// extracted by mini-css-extract-plugin
export var actionButton = "_72-0";
export var fileInput = "_72-2";
export var paperclip = "_72-1";